<template>
    <b-modal
        id="modalUploadPhoto"
        ref="modalUploadPhoto"
        :lazy="true"
        title-tag="h2"
        title="Upload Photo"
    >
        <b-form-group label="File: " class label-cols="3" label-for="file">
            <b-form-file v-model="data.file" class="mt-2" plain></b-form-file>
        </b-form-group>
        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!loading"
                @click="$refs.modalUploadPhoto.hide('cancel')"
                class="float-left"
                variant="secondary"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <b-button
                    v-if="!loading"
                    @click="save"
                    class="float-left"
                    variant="primary"
                    >Save</b-button
                >
            </div>
        </div>
    </b-modal>
</template>
<script>
import Client from "@/services/client";
import Patient from "@/services/patient";
import { STAFF_PROFILE_TAB_OPTIONS } from "@/store/staff.js";
import staffService from "@/services/staff";

export default {
    name: "ModalUploadPhoto",
    components: {},
    computed: {
        details() {
            return this.$store.getters["staff/staffDetails"];
        },
        refresh() {
            return this.$store.getters["staff/refresh"];
        }
    },
    data() {
        return {
            loading: false,
            module: "",
            data: {
                file: null
            }
        };
    },
    methods: {
        open(module) {
            this.module = module;
            this.$refs.modalUploadPhoto.show();
        },
        save() {
            let self = this;
            let data = new FormData();
            
            if(!self.data.file) return;
  
            self.loading = true;
            data.append("file", self.data.file);
            switch (self.module) {
                case "CLIENT":
                    data.append("id", self.$store.state.client.client_id);
                    Client.updateClientPhoto(data).then(response => {
                        if (response.state == 0) {
                            self.$refs.modalUploadPhoto.hide();
                            self._message(response.message, "success");
                            self.$store.dispatch("client/getClientDetails", {
                                id:
                                    self.$store.state.client.client_details
                                        .encoded_id,
                                encoded: true
                            });
                        } else {
                            self._message(response.message, "danger");
                            this.$refs.modalUploadPhoto.hide();
                        }
                    });
                    break;
                case "PATIENT":
                    data.append(
                        "id",
                        self.$store.state.patient.patientDetails.id
                    );
                    Patient.updatePatientPhoto(data).then(response => {
                        if (response.state == 0) {
                            self.$refs.modalUploadPhoto.hide();
                            self._message(response.message, "success");
                            self.$store
                                .dispatch("patient/getPatientDetails", {
                                    id:
                                        self.$store.state.patient.patientDetails
                                            .encoded_id,
                                    encoded: true
                                })
                                .then(details => {
                                    this.$root.$emit(
                                        "update-patient-details",
                                        details
                                    );
                                });
                        } else {
                            self._message(response.message, "danger");
                            this.$refs.modalUploadPhoto.hide();
                        }
                    });
                    break;
                case "STAFF":
                    data.append(
                        "actor_id",
                        this.details.actor_id
                    );
                    
                    staffService.savePhoto(data).then(response => {
                        const {code,message}=response;
                        if (code == 200) {
                            self.$refs.modalUploadPhoto.hide();
                            self._message(message, "success");
                            this.$store.commit(
                            "staff/setRefresh",
                            this.refresh + 1
                        );
                        this.$store.commit(
                            "staff/setStaffProfileTab",
                            STAFF_PROFILE_TAB_OPTIONS.profile
                        );
                        } else {
                            self._message("Error: Cannot Upload Photo", "danger");
                            this.$refs.modalUploadPhoto.hide();
                        }
                    });
                    break;
                default:
                    break;
            }
        }
    }
};
</script>
